import React, { useMemo } from 'react';
import cn from 'clsx';
import { Typography, TypographyTextProps } from '../typography';
import { imageNameContainer, imageAddText, sizeStylesMap } from './image-name-styles';

type Size = 'l' | 'm';

const SIZE_PROPS_MAPS: Record<Size, TypographyTextProps> = {
  l: {
    variant: 'l',
    size: 'subtitle',
  },
  m: {
    variant: 'm',
    size: 'body_accent',
  },
};

type ImageNameProps = {
  adaptive?: boolean;
  addText?: string;
  className?: string;
  isShowImageAddText?: boolean;
  name: string;
  size?: Size;
};

export const ImageName: React.FC<ImageNameProps> = ({
  adaptive,
  className,
  name,
  isShowImageAddText,
  addText = '',
  size = 'l',
}) => {
  const nameProps = useMemo(() => SIZE_PROPS_MAPS[size], [size]);
  const sizeStyles = useMemo(() => sizeStylesMap[size], [size]);

  return (
    <div className={cn(className, imageNameContainer, sizeStyles)}>
      <Typography adaptive={adaptive} color="text-invert" {...nameProps}>
        {name}
      </Typography>
      {isShowImageAddText && (
        <Typography variant="s" size="body_short" color="text-invert" className={imageAddText}>
          {addText}
        </Typography>
      )}
    </div>
  );
};
